







































































































import Vue from "vue"
import {Office} from "@/model/entity/office/office"
import {Employee} from "@/model/entity/employee/employee"
import EmployeeEditor from "@/components/user-administration/EmployeeEditor.vue"
import {employeeService, IEmployeeService} from "@/model/service/employee/employee-service"

interface Data {
  page: number
  size: number
  total: number
  isAdd: boolean
  employeeService: IEmployeeService
}

export default Vue.extend({
  components: {EmployeeEditor},
  data(): Data {
    return {
      page: 1,
      size: 12,
      total: 0,
      isAdd: false,
      employeeService: employeeService
    }
  },
  props: {
    office: {
      type: Object as () => Office,
      required: true
    },
    employees: {
      type: Array as () => Employee[],
      default: () => {
        return []
      }
    }
  },
  methods: {
    addEmployee(employee: Employee) {
      const vm = this
      employee.office = vm.office
      if (exists(vm.office.id)) {
        vm.$emit("simulate")
        employeeService
          .create(employee)
          .then(response => {
            vm.employees.push(response.data)
            vm.isAdd = false
          }, (response) => {
            if (response.data && response.data.message) {
              vm.$error(response.data.message)
            } else {
               vm.$error(response)
            }
            vm.endLoad()
          })
          .catch(error => vm.$error(error.message))
      } else {
        vm.employees.push(employee)
        vm.isAdd = false
        vm.$emit("simulate")
      }
    },
    updateEmployee(payload: any, index: number) {
      const vm = this
      if (exists(payload.employee.id)) {
        if (!exists(payload.call)) {
          vm.$emit("simulate")
        }
        employeeService
          .modify(payload.employee)
          .then(response => {
            Object.assign(vm.employees[index], response.data)
            if (exists(payload.call)) {
              payload.call()
            }
          }, (response) => {
            if (response.data && response.data.message) {
              vm.$error(response.data.message)
            } else {
               vm.$error(response)
            }
            vm.endLoad()
          })
          .catch(error => vm.$error(error.message))
      } else {
        Object.assign(this.employees[index], payload.employee)
        vm.$emit("simulate")
      }
    },
    deleteEmployee(index: number) {
      this.employees.splice(index, 1)
    },
    becomeEmployee(employeeId: number) {
      const vm = this
      vm.$http
        .get("/employee/change_to/" + employeeId)
        .then(response => {
          vm.$store.commit("setAuthenticatedEmployee", response.data)
          vm.$router.push("/")
        })
        .catch(e => console.log(e))
    }
  },
  computed: {
    pagedEmployees(): Employee[] {
      return this.employees.slice((this.page - 1) * this.size, this.page * this.size)
    }
  }
})
